import { ApiActionTypes, buildApiTypeAction } from "src/common/apiLoader/apiLoaderUtils";

const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const GET_DASHBOARD_DATA_API = buildApiTypeAction(GET_DASHBOARD_DATA, ApiActionTypes.REQUEST)
export const GET_DASHBOARD_DATA_API_SUCCESS = buildApiTypeAction(GET_DASHBOARD_DATA, ApiActionTypes.SUCCESS)
export const GET_DASHBOARD_DATA_API_ERROR = buildApiTypeAction(GET_DASHBOARD_DATA, ApiActionTypes.ERROR)